module.exports = __webpack_public_path__ + "sf-pro-text-medium.svg?778c42ef6c0bf2090f9fe44668d94a77";